/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from 'react';
import { AuthProvider } from './src/contexts/AuthContext';
import { MDXProvider } from '@mdx-js/react';
import defaultComponents from './src/components/mdx-components';

import './src/styles/global-classes.scss';
require("prism-solarized-dark/prism-solarizeddark.css");
require("prismjs/plugins/line-numbers/prism-line-numbers.css");

// Wrap root element with AuthProvider and MDXProvider
// MDXProvider makes components available globally for MDX content
export const wrapRootElement = ({ element }) => {
  return (
    <AuthProvider>
      <MDXProvider components={defaultComponents}>
        {element}
      </MDXProvider>
    </AuthProvider>
  );
};
